async function useFetch(path) {
  const response = await fetch(`https://anrat-backend.onrender.com/api/${path}`);

  if (!response.ok) {
    const message = `An error has occured: ${response.status}`;
    console.log("UseFetch error : ", message);
    // throw new Error(message);
  }

  const json = await response.json();
  // Strapi v5 : extraire .data si présent, sinon retourner json brut (routes custom)
  return json.data !== undefined ? json.data : json;
}

async function usePost(path, data) {
  // Routes custom qui n'utilisent pas le format Strapi v5 standard
  const customRoutes = ['subscribe', 'subscribe-indi', 'subscribe-insti'];
  const isCustomRoute = customRoutes.some(route => path.includes(route));

  let request = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(isCustomRoute ? data : { data: data }),
  };
  try {
    const response = await fetch(
      "https://anrat-backend.onrender.com/api/" + path,
      request
    );
    return response;
  } catch (error) {
    return error;
  }
}

export { useFetch, usePost };
